/* TR22: merge "More <type>" into the "You may also like" rail on phones. Loaded (deferred) by
   sections/product-recommendations.liquid when its merge_phone_rail setting is on. Moves the cards both sections already
   render, so it makes no request. Phones only (under 770 px, decided once at load). The cards are moved, not copied, in
   the order: recommendations first, then the type cards the rail does not already hold, at most 12 in all. The type
   section is hidden only after its cards are in the rail; if anything does not arrive, it stays as it was. */
(function () {
  /* B5P P4 (2026-10-29): with "Others also bought" on (product-recommendations[data-umbra-ab]) nothing is merged; see abStart below. */
  if (document.querySelector('product-recommendations[data-umbra-ab]')) { abStart(); return; }
  if (!window.matchMedia || !window.matchMedia('(max-width: 768.98px)').matches) return;
  var MAX = 12;
  var done = false;
  var timer;
  var observer;

  function handleOf(li) {
    var a = li.querySelector('a[href*="/products/"]');
    var m = a ? a.getAttribute('href').split('?')[0].match(/\/products\/([^\/]+)/) : null;
    return m ? m[1] : '';
  }

  function addLine(recs, list) {
    var box = list.parentNode;
    if (box.querySelector('.umbra-rail-line')) return;
    var line = document.createElement('div');
    line.className = 'umbra-rail-line';
    line.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('i');
    line.appendChild(thumb);
    box.appendChild(line);
    var queued = false;
    function paint() {
      queued = false;
      var cw = list.clientWidth;
      var sw = list.scrollWidth;
      if (!cw || sw <= cw + 1) {
        line.hidden = true;
        return;
      }
      line.hidden = false;
      thumb.style.width = (cw / sw * 100) + '%';
      thumb.style.transform = 'translateX(' + (list.scrollLeft / cw * 100) + '%)';
    }
    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(paint);
    }
    list.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    paint();
  }

  function attempt(force) {
    if (done) return;
    var recs = document.querySelector('product-recommendations[data-merge-rail]');
    if (!recs) {
      finish();
      return;
    }
    var list = recs.querySelector('.products-grid-container > ul');
    if (recs.hasAttribute('data-recs-empty')) {
      if (force) finish();
      return;
    }
    if (!list || recs.querySelector('.recs-ghost, .recs-skeleton') || !list.children.length) return;
    var sub = document.querySelector('umbra-subcategory-rail');
    if (sub && sub.classList.contains('umbra-subcat--pending')) {
      if (!force) return;
      sub = null;
    }
    var pairs = document.querySelector('[data-umbra-pairs]');
    if (pairs) {
      /* ID2 B3: a product shown in "Pairs well with" is not repeated in the rail. */
      var shown = (pairs.getAttribute('data-handles') || '').split(' ');
      Array.prototype.slice.call(list.children).forEach(function (li) {
        if (shown.indexOf(handleOf(li)) !== -1) list.removeChild(li);
      });
    }
    if (sub) {
      var seen = {};
      seen[sub.getAttribute('data-current-handle')] = 1;
      shown = shown || (pairs ? (pairs.getAttribute('data-handles') || '').split(' ') : []);
      shown.forEach(function (h) { if (h) seen[h] = 1; });
      Array.prototype.forEach.call(list.children, function (li) { seen[handleOf(li)] = 1; });
      var cards = Array.prototype.filter.call(sub.querySelectorAll('ul > li'), function (li) {
        return !li.classList.contains('umbra-subcat__ghost');
      });
      cards.forEach(function (li) {
        var key = handleOf(li);
        if (!key || seen[key] || list.children.length >= MAX) return;
        seen[key] = 1;
        list.appendChild(li);
      });
      if (cards.length) {
        var wrap = sub.closest('.shopify-section') || sub;
        wrap.hidden = true;
      }
    }
    addLine(recs, list);
    finish();
  }

  function finish() {
    done = true;
    if (observer) observer.disconnect();
    clearTimeout(timer);
  }

  function start() {
    attempt(false);
    if (done) return;
    observer = new MutationObserver(function () { attempt(false); });
    var recs = document.querySelector('product-recommendations[data-merge-rail]');
    var sub = document.querySelector('umbra-subcategory-rail');
    if (recs) observer.observe(recs, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-recs-empty'] });
    if (sub) observer.observe(sub, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    timer = setTimeout(function () { attempt(true); finish(); }, 6000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  /* B5P P4: two rails, every tier. "You may also like" (umbra-subcategory-rail, filled by priority in Liquid) and "Others also
     bought" (this section). Once both have their cards: no card of "You may also like" repeats Pairs well with or the product;
     "Others also bought" drops the product itself and every handle already shown above, keeps data-limit cards, tops up to
     data-limit from its hidden spares (the popular collection; R10-P4c, was 4), drops the unused spares and hides itself
     with fewer than 2. From 770 the section's CSS still shows 4 in 4 columns (R5-P4b). On phones both
     are bleeding sideways rails like Designer Picks (umbra-pdp-rail.css), with no slider line. Makes no request. */
  function abStart() {
    var abDone = false, abForce = false, abTimer, abObs;
    function handles(attr) {
      var out = [];
      (attr || '').split(/[\s,]+/).forEach(function (h) { if (h) out.push(h); });
      return out;
    }
    function abRun(force) {
      if (abDone) return;
      force = force || abForce;
      var recs = document.querySelector('product-recommendations[data-umbra-ab]');
      if (!recs) { abFinish(); return; }
      var list = recs.querySelector('.products-grid-container > ul');
      var empty = recs.hasAttribute('data-recs-empty');
      if (!empty && (!list || recs.querySelector('.recs-ghost, .recs-skeleton') || !list.children.length)) { return; }
      var sub = document.querySelector('umbra-subcategory-rail');
      if (sub && sub.classList.contains('umbra-subcat--pending') && !force) return;
      var seen = {};
      seen[recs.getAttribute('data-current-handle')] = 1;
      var pairs = document.querySelector('[data-umbra-pairs]');
      handles(pairs && pairs.getAttribute('data-handles')).forEach(function (h) { seen[h] = 1; });
      /* B6E P3: the collection rail (snippets/umbra-pdp-collection-rail.liquid) comes first; nothing below repeats its cards */
      var fam = document.querySelector('[data-umbra-family-rail]');
      handles(fam && fam.getAttribute('data-handles')).forEach(function (h) { seen[h] = 1; });
      if (sub) {
        var subList = sub.querySelector('.products-grid-container > ul');
        if (subList) Array.prototype.slice.call(subList.children).forEach(function (li) {
          if (li.classList.contains('umbra-subcat__ghost')) return;
          var k = handleOf(li);
          if (k && seen[k]) { subList.removeChild(li); return; }
          if (k) seen[k] = 1;
        });
        handles(sub.getAttribute('data-handles')).forEach(function (h) { seen[h] = 1; });
      }
      if (!empty) {
        var max = parseInt(recs.getAttribute('data-limit'), 10) || 8;
        /* B6E P3: with the collection rail on the page, "Others also bought" holds 4 cards */
        if (fam) max = Math.min(max, 4);
        var real = [], spare = [];
        Array.prototype.slice.call(list.children).forEach(function (li) { (li.hasAttribute('data-umbra-fill') ? spare : real).push(li); });
        var kept = 0;
        real.forEach(function (li) {
          var k = handleOf(li);
          if (!k || seen[k] || kept >= max) { list.removeChild(li); return; }
          seen[k] = 1;
          kept++;
        });
        spare.forEach(function (li) {
          var k = handleOf(li);
          if (kept < max && k && !seen[k]) { seen[k] = 1; kept++; li.removeAttribute('data-umbra-fill'); li.hidden = false; return; }
          list.removeChild(li);
        });
        if (kept < 2) {
          var wrap = recs.closest('.shopify-section') || recs;
          var hide = function () { wrap.hidden = true; };
          if (window.umbraShrink) window.umbraShrink(wrap, hide, 0); else hide();
        }
      }
      abFinish();
    }
    function abFinish() {
      abDone = true;
      if (abObs) abObs.disconnect();
      clearTimeout(abTimer);
    }
    function abGo() {
      abRun(false);
      if (abDone) return;
      abObs = new MutationObserver(function () { abRun(false); });
      var recs = document.querySelector('product-recommendations[data-umbra-ab]');
      var sub = document.querySelector('umbra-subcategory-rail');
      if (recs) abObs.observe(recs, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-recs-empty'] });
      if (sub) abObs.observe(sub, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      /* R5-P4: the 8 s timer only stops waiting for a pending rail 1; the run still waits for this rail's cards or data-recs-empty */
      abTimer = setTimeout(function () { abForce = true; abRun(true); }, 8000);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', abGo, { once: true });
    else abGo();
  }
}());
